module.exports = __webpack_public_path__ + "img/conference.3c50a569.png";